import React from 'react';
import { connect } from 'react-redux';
import { get } from '~/actions/customersNew';
import FontIcon from 'react-toolbox/lib/font_icon';
import Spinner from '~/components/Spinner';
import style from './style.scss';

class Tag extends React.Component {
  static contextTypes = {
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: props.id && !props.item,
    };
  }

  componentDidMount() {
    if (this.state.loading) {
      get(this.props.dispatch, this.context.apiClient, this.props.id)
        .catch(() => false).then(() => this.setState({ loading: false }));
    }
  }

  render() {
    const { id, item, className, dispatch, ...rest } = this.props;

    return (
      <div className={[style.tag, className, (this.state.loading || !item) && style.loading, item && item.get('removed') && style.removed].join(' ')} onClick={e => { e.preventDefault(); e.stopPropagation(); }} {...rest}>
        {this.state.loading && <Spinner />}
        {!this.state.loading && !item && <div><FontIcon value="people" />{id === '' ? 'Select a customer' : 'Not found'}</div>}
        {!this.state.loading && item && <div onClick={() => this.context.dialogPush('customersNew', { id })}>
          <FontIcon value="people" />
          {!item.get('company') || <span>{item.get('company')}&nbsp;</span>}
          {!item.get('firstName') || <span>{item.get('firstName')}&nbsp;</span>}
          {!item.get('lastName') || <span>{item.get('lastName')}&nbsp;</span>}
          {!item.get('company') && !item.get('firstName') && !item.get('lastName') && item.get('partynutsId') && <span>partynuts #{item.get('partynutsId')}&nbsp;</span>}
        </div>}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  item: state.getIn(['customersNew', 'items', props.id]),
});

export default connect(mapStateToProps)(Tag);



// WEBPACK FOOTER //
// ./app/components/Tag/Customer.js